import React from "react";
import "./About.css";
import AboutSection from "./AboutSection";
import { Fade } from "react-reveal";
import { useLanguage } from "../../context/LanguageContext";
import { getTranslation } from "../../translations/translations";

export default function About(props) {
  const theme = props.theme;
  const { language } = useLanguage();

  return (
    <div className="main" id="about">
      <div className="about-header-div">
        <Fade bottom duration={2000} distance="20px">
          <h1 className="about-header" style={{ color: theme.text }}>
            {getTranslation(language, "about_our_church")}
          </h1>
        </Fade>
      </div>
      <AboutSection theme={theme} />
    </div>
  );
}
